import http from '@/lib/admin/http'
import {Message, MessageBox} from 'element-ui'

export default {
  namespaced: true,
  state: {
    url: '/api/admin/articles',
    createUrl: '/api/admin/articles',
    parentUrl: '/api/admin',
    articles_url: 'http://cxedu.xqp.com/articles_detail/',
    list: [],
    newArticles: {},
    Articles: {},
    loading: false,
    page: {
      total: 0,
      pageSize: 8,
      currentPage: 1,
    },
    search: {
      page: 1
    },
    ruleForm:{},
    rules: {
      cate_id: [{required: true, message: '请选择主要分类', trigger: 'blur'}],
      // img: [{required: true, message: '请上传文章图片', trigger: 'blur'}],
      cateList: [{required: true, message: '请选择次要分类', trigger: 'blur'}],
      title: [{required: true, message: '请输入文章标题', trigger: 'blur'}],
      from: [{required: true, message: '请输入文章来源', trigger: 'blur'}],
  },
    cateList: [],
    content:"",
  },
  mutations: {
      removeSearch(state,search){
          state.search.cate_id = 0;
          state.search.title = "";
          state.search.page = 1;
      },
    setSearch(state, search){
        state.search = search;
    },
    setList(state, data) {
      state.list = data;
      state.loading = false;
    },
    setPage(state, page) {
      state.page = page;
      state.search.page = state.page.currentPage;
    },
    loading(state) {
      state.loading = true;
    },
    closeLoading(state) {
      state.loading = false;
    },
    resetCreate(state) {
      state.newArticles = {};
    },
    setArticles(state, Articles) {
      state.Articles = Articles;
    },
    resetArticles(state) {
      state.Articles = {}
    },
    cateList(state, data) {
      state.cateList = data;
    },
    setContent(state, content) {
      state.content = content;
    }
  },
  actions: {
    /**
     * 获取列表
     * @param  context
     * @param  page
     */
    getList(context, page) {
      //传入分页
      return new Promise((succes, faild) => {

        context.commit('loading');
        if (page) {
          context.commit('setPage', page);
        }
        //遮罩
        context.commit('loading');

        //获取数据
        http.getData(context.state.url, context.state.search).then(res => {
          //赋值
          context.commit('setList', res.data.list.data);

          let page = {
            'pageSize': res.data.list.per_page,
            'total': res.data.list.total,
            'currentPage': res.data.list.current_page,
          };

          //分页赋值
          context.commit('setPage', page);

          succes();
        }).catch(faild)
      });


    },

    /**
     * 获取全部分类
     * @param  context
     * @param  page
     */
    getCateList(context) {
      return new Promise((success, faild) => {
        http.getData(context.state.parentUrl + "/getCateList")
            .then(res => {
              context.commit('closeLoading');
              context.commit('cateList', res.data.data);
              success(res.data);
            })
            .catch(res => {
              context.commit('closeLoading');
            });
      })
    },

    create(context, articles) {
      return new Promise((success, faild) => {
        http.postData(context.state.createUrl, articles).then(res => {
          if (res.result.code == 1) {
            context.commit('resetCreate');
            success(res);
          } else {
            Message.error(res.result.message);
          }
        }).catch(faild)
      })
    },
    /**
     * 获取详情
     * @param  context
     * @param  articles
     * @returns  {Promise<any>}
     */
    show(context, articles) {
      return new Promise((success, faild) => {
        context.commit('loading');
        context.commit('resetArticles');
        http.getData(context.state.url + '/' + articles.id, articles)
          .then(res => {
            context.commit('setArticles', res.data.data);
            context.commit('setContent', res.data.data.content);
            success(res.data)
          })
          .catch(res => {
            context.commit('closeLoading');
            faild()
          });
      })
    },

    /**
     * 更新
     * @param  context
     * @param  Articles
     * @returns  {Promise<any>}
     */
    update(context) {
      return new Promise((success, faild) => {
        http.putData(context.state.url + '/' + context.state.Articles.id, context.state.Articles)
          .then(res => {
            if (res.result.code == 1) {
              success(res.data)
            } else {
              Message.error(res.result.message);
            }
          }).catch(faild)
        ;
      })
    },
    destory(context, Articles) {
      MessageBox.confirm('确定要删除此数据？')
        .then(_ => {
          context.commit('loading');
          http.deleteData(context.state.url + '/' + Articles.id).then(res => {
            context.dispatch('getList');
          })
        })
        .catch(_ => {
          Message.error('未进行操作');
        });
    }
  },
  getters: {}
}



// WEBPACK FOOTER //
// ./src/vuex/modules/admin/articles.js